import { render, staticRenderFns } from "./ShRecipeBox.vue?vue&type=template&id=edfb4298&"
import script from "./ShRecipeBox.vue?vue&type=script&lang=js&"
export * from "./ShRecipeBox.vue?vue&type=script&lang=js&"
import style0 from "./ShRecipeBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports